// extracted by mini-css-extract-plugin
export default {"container":"PageNotFound_container__0Jcw0","text":"PageNotFound_text__7umLO","image":"PageNotFound_image__eAR+9"};